import React from 'react';

import BaseClass from '../BaseClass';

import {httpPost, pcUrl,} from '@/utils/tools';

export default class App extends BaseClass {
    constructor(props) {
        super(props);
        this.state = {
            'list': [],
            'orderStatusList': {
                1: '已开通',
                2: '已删除',
            },
            'studyStatusList': {
                0: '待学习',
                1: '学习中',
                2: '已学完',
            },
        };
    }

    componentDidMount() {
        this.getList();
    }

    getList() {
        let url = pcUrl('/order');
        httpPost(url, {}, 'GET')
            .then(data => {
                this.setState({
                    'list': data,
                });
            });
    }


    render() {
        return (
            <>
                <div className="index-panel user-profile-panel">
                    <div className="captain">
                        <h3>
                            <span className="clips index-panel-ddjl-ico"></span>
                            课题记录
                        </h3>
                    </div>
                    <div className="panel-body">
                        {this.state.list.length > 0 ? (
                            <table className="index-table">
                                <tr>
                                    <th width="30%">
                                        课题名称
                                    </th>
                                    <th className="text-center">
                                        学习状态
                                    </th>
                                    <th className="text-center">
                                        课题状态
                                    </th>
                                    <th width="25%" className="text-center">
                                        开通时间
                                    </th>
                                </tr>
                                {this.state.list.map((row, index) => (
                                    <tr>
                                        <td> {row.courseName || '待选题'} </td>
                                        <td className="text-center">
                                            <span
                                                className="text-green">{this.state.studyStatusList[row.studyStatus]}</span>
                                        </td>
                                        <td className="text-center">
                                            <span
                                                className="text-green">{this.state.orderStatusList[row.orderStatus]}</span>
                                        </td>
                                        <td className="text-center">
                                            <span className="text-center">
												{row.payTime || row.addTime || row.createTime}
											</span>
                                        </td>
                                    </tr>
                                ))}
                            </table>
                        ) : (
                            <div className="padding-20 text-center text-gray">暂无数据</div>
                        )}
                    </div>
                </div>
            </>
        );
    }
}
